import React from 'react'
import { IoChevronForwardOutline } from 'react-icons/io5'
import { Box, Button, Typography } from '@mui/material'
import moment from 'moment'
import RouterHook from '../../../contexts/RouterHook'

export default function LabelPedido({ pedido }) {
  const serverRouter = RouterHook()

  return (
    <Box sx={styles.containLabelPedido}>
      <Typography variant='h5' sx={styles.titlePedido}>
        {`${moment(pedido.dataInicio).format('hh:mm')} às ${moment(pedido.dataFinal).format('hh:mm')}`}
      </Typography>
      <Typography sx={styles.labelPedido}>{`${moment(pedido.dataInicio).startOf('minute').fromNow().toLowerCase()} ${
        moment(pedido.dataInicio).isBefore(moment())
          ? `, em ${moment(pedido.dataInicio).format('DD/MM/YY')}`
          : `, em ${moment(pedido.dataInicio).format('DD/MM/YY')}`
      }`}</Typography>
      <Button
        variant='text'
        sx={styles.buttonDetalhes}
        endIcon={<IoChevronForwardOutline size={18} />}
        onClick={() => {
          serverRouter('agendamento', pedido.idpedido)
        }}
      >
        Ver detalhes
      </Button>
    </Box>
  )
}

const styles = {
  containLabelPedido: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
    height: 'auto',
    padding: '5px',
  },
  titlePedido: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '-3px',
  },
  labelPedido: {
    fontSize: '14px',
    color: 'gray',
  },
  buttonDetalhes: {
    fontSize: '14px',
    color: '#00cda4',
    fontWeight: 'bold',
    padding: '0px',
    margin: '0px',
    '&:hover': {
      color: 'var(--color-text-hig)',
    },
  },
}
